import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Button } from 'reactstrap';

import { callApi, formatAmount } from '../../utils';
import { showError, showInfo } from '../../actions/notificationActions';

// import SuccessTick from './SuccessTick';
// import ErrorTick from './ErrorTick';
// import Pagination from './Pagination';
// import SearchForm from './SearchForm';
import {
  openCreateSupervisorModal,
  openSupervisorModal,
  openSupervisorLogsModal,
} from '../../actions/modalActions';
import CreateSupervisorModal from '../CreateSupervisorModal';
import DataTable, { PageHeader } from '../DataTable';

class Supervisors extends Component {
  state = {
    supervisors: [],
    query: '',
    page: 1,
    limit: 30,
    loading: false,
  };

  componentWillMount() {
    this.loadSupervisors();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadSupervisors = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    this.startLoad();
    callApi(`/agentsupervisors/wallet`)
      .then(({ data = [] }) => {
        this.setState({ loading: false, supervisors: data });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  blockSupervisor = (id, newStatus, e) => {
    e.stopPropagation();
    if (
      !window.confirm(`${newStatus === '0' ? 'Block' : 'Unblock'} supervisor?`)
    )
      return;
    this.setState({ loading: true });
    callApi('/agentsupervisors/status', { id, status: newStatus }, 'post')
      .then((res) => {
        // this.setState({ loading: false });
        this.props.dispatch(showInfo(res.message));
        this.loadSupervisors();
      })
      .catch((err) => {
        this.setState({ loading: false });
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadSupervisors();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  openUser = (data) => {
    this.props.dispatch(openSupervisorModal(data));
  };

  openLogs = (data, e) => {
    e.stopPropagation();
    this.props.dispatch(openSupervisorLogsModal(data));
  };

  openSupervisor = (id) => {
    this.props.history.push(`/supervisors/${id}`);
  };

  refresh = () => {
    window.location.reload();
  };

  render() {
    const { supervisors, loading } = this.state;
    return (
      <div className="container-fluid">
        <CreateSupervisorModal refresh={this.refresh} />
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader title="Supervisors" subtitle="All Supervisors">
              <Button
                // size="sm"
                // disabled={}
                color={'primary'}
                onClick={() => {
                  this.props.dispatch(openCreateSupervisorModal());
                }}
              >
                Create Supervisor
              </Button>
            </PageHeader>

            <DataTable minWidth={800} loading={loading}>
              <thead className="text-primary">
                <tr>
                  <th>Supervisor ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Balance</th>
                  <th>Disco</th>
                  <th>Email</th>
                  {/* <th>Wallet</th> */}
                </tr>
              </thead>

              <tbody>
                {supervisors.map((u, i) => (
                  <tr
                    onClick={() => this.openSupervisor(u.id)}
                    key={u.id}
                    style={{ cursor: 'text' }}
                  >
                    <td>{u.id}</td>
                    <td>{u.name}</td>
                    <td>{u.phone}</td>
                    <td>{formatAmount(u.wallet)}</td>
                    <td>{u.disco}</td>
                    {/* <td>{u.email}</td> */}
                    <td>
                      {
                        u.email /* <Button
                            size="sm"
                            color="primary"
                            onClick={() => this.openUser(u)}
                          >
                            Wallet
                          </Button> */
                      }
                      {''}
                      {/* <Button
                            size="sm"
                            color="primary"
                            onClick={(e) => this.openLogs({ id: u.id }, e)}
                          >
                            Transactions
                          </Button> */}
                    </td>
                    {/* <td>{u.email}</td>
                        <td>{formatDate(u.created_at)}</td>
                        <td>
                          {u.social_follow === '0' ? (
                            <ErrorTick />
                          ) : (
                            <SuccessTick />
                          )}
                        </td>
                        <td>{formatAmount(Number(u.wallet) / 100)}</td> */}
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(Supervisors);
